export const SUB_NODE_WORKFLOW_STATE = 'subNodeWorkflowState';
export const NODE_WORKFLOW_STATE = 'nodeWorkFlowState';

export default {
  NODE_WORKFLOW_STATE,
  SUB_NODE_WORKFLOW_STATE,
};
